import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';

const LanguageContext = createContext();

const TRANSLATION_DURATION = 1600;

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const saved = localStorage.getItem('language');
        if (saved) return saved;
        const browserLang = navigator.language || navigator.userLanguage || '';
        return browserLang.toLowerCase().startsWith('it') ? 'it' : 'en';
    });
    const [isTranslating, setIsTranslating] = useState(false);
    const [pendingLanguage, setPendingLanguage] = useState(null);

    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);

    const toggleLanguage = useCallback(() => {
        if (isTranslating) return;
        const next = language === 'en' ? 'it' : 'en';
        setPendingLanguage(next);
        setIsTranslating(true);
        setTimeout(() => {
            setLanguage(next);
            setIsTranslating(false);
            setPendingLanguage(null);
        }, TRANSLATION_DURATION);
    }, [language, isTranslating]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, isTranslating, pendingLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};
